import BotoesFluxoMixin from '@/produto/spa/planejamento-contrato/form/BotoesFluxoMixin';

export default BotoesFluxoMixin;
